export default __webpack_public_path__ + "static/media/pdfLogo.3f5266b0.svg";